<template>
  <div class="qr-cd-guide-wrapper">
    【仮QRコード発行者情報変更手順】
    <div>
      事前に登録した住民情報を検索し、下の表より修正することができます。<br />
      ➀仮QRコード発行者の住民情報を修正する場合は、条件を指定し住民情報を絞り込みます。<br />
      ➁一覧に表示している住民情報から、修正したい住民情報の右端の「編集」ボタンを押下します。<br />
      ➂修正したい住民の情報が表示されます。修正したい内容を更新し、「更新」ボタンを押下します。<br />
    </div>
  </div>
</template>

<script>
export default {
  name: "TemporaryQrCodeIssueGuide"
};
</script>
